module.exports = __webpack_public_path__ + "static/media/img-emandamento-sanpaolo-jun23-3.f772197f.jpg";